import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { EMPTY, Subject } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { Aplicacao } from './_classes/aplicacao';
import { TabFtSrv } from './_classes/tab-ft-srv';
import { AplicacaoService } from './_servicos/aplicacao.service';
import { EnvService } from './_servicos/env.service';
import { LoaderService } from './_servicos/loader/loader.service';
import { MenuService } from './_servicos/menu.service';
import { RestService } from './_servicos/rest.service';
import { ServidorService } from './_servicos/servidor.service';
import { ModalAlertaService } from './shared/modal-alerta.service';
import { FotoService } from './_servicos/foto.service';
import { Servidor } from './_classes/servidor';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  title = 'meu-portal';

  defaultElevation = 2;
  raisedElevation = 8;

  apiUrl: string = '';

  erros$ = new Subject<boolean>();

  constructor(
    public rest: RestService,
    private menuService: MenuService,
    private alertService: ModalAlertaService,
    private servService: ServidorService,
    private router: Router,
    private _sF: FotoService,
    private _envS: EnvService,
    private _appS: AplicacaoService,
    private readonly _kcS: KeycloakService,
    public loaderService: LoaderService
  ) {
    this.apiUrl = _envS.apiUrl;
    this.loaderService.isLoading.next(true);
    //this.verificarVersaoAplicacao();
  }

  ngOnInit() {
    this.verificarVersaoAplicacao();
  }

  public get appFront(): Aplicacao {
    return this._appS.appFront;
  }

  public get appBack(): Aplicacao {
    return this._appS.appBack;
  }

  alterarLoading() {
    this.loaderService.isLoading.next(true);
  }

  verificarVersaoAplicacao(): void {
    if (!this.appBack || this.appBack.data == '') {
      this._appS.getAplicacao().subscribe({
        next: (x: Aplicacao) => {
          //console.log('this.appBack', x);
          this.carregarUsuarioKeycloak();
        },
        error: (e) => {
          //console.log('Erro ao buscar dados do servidor', e.message);
          this.router.navigate(['/servidor-inativo']);
          return EMPTY;
        },
        complete: () => {},
      });
    } else {
      this.carregarUsuarioKeycloak();
    }
  }

  carregarUsuarioKeycloak() {
    if (!this.servService.estaCarregadoServidor()) {
      this.servService
        .getServidorComFuncao2()
        .then(() => this.depoisDeUsuarioLogado());
    }
    //this.servService.getServidorComFuncao(() => {        this.depoisDeUsuarioLogado();      });    }
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }

  carregarFoto(idServ: string) {
    //console.log('carregando Foto', mat);
    if (idServ) {
      this.rest
        .getFoto(idServ)
        .pipe(
          take(1),
          catchError((e) => {
            return EMPTY;
          })
        )
        .subscribe((a: TabFtSrv) => {
          //console.log('carregou Foto', a);
          this._sF.removeFoto(idServ);
          if (a && a.foto) {
            this._sF.storeFoto(a.foto, idServ);
          }
        });
    }
  }

  depoisDeUsuarioLogado(): any {
    //console.log('depoisDeUsuarioLogado', this._envS.servidor);
    this.carregarFoto(this._envS.servidor?.idServidor?.toString());
    this.rest
      .getRespondeuRecadastramento(this._envS.servidor?.idServidor)
      .subscribe(
        (a) => {
          if (a) {
            this.menuService.emitirMostrarMenu(this._envS.mostrarMenu);

            if (this.router.url == '/') {
              this.router.navigateByUrl('/inicio');
            }
          } else {
            this._kcS.logout;
            this.router.navigate(['/recadastramento']);
          }
        },
        (e) => {
          //alert(e);
          return EMPTY;
        }
      );
    return 0;
  }
}
